
export const STORAGE = {
    RESERVATION_CODE: 'reservationCode',
    RESERVATION_EXPIRATION_TIME: 'reservationClearOut',
    SUCCESS_MESSAGE: 'successMessage',
    OCCUPANCY_RULE: 'occupancyRule',
    COMPANY_NAME: 'companyName',
    IS_POSITIVE: 'isPositive',
    CHECK_IN_DATE: 'checkInDate',
    COVID_DATE: 'covidDate',
    CURRENT_RULES: 'currentRules',
    CHECK_IN_HISTORY: 'checkInHistory'
}

export const PATHS = {
    GOOD_DAY: '/good-day',
    RESERVATION_CHECK: '/reservation-check',
    VIEW_RESERVATIONS: '/view-reservations',
    SAFETY_REJECTION: '/safety-rejection',
    COVID_TEST_DATE: '/covid-test-date',
    COVID_CHECK: '/covid-check',
    CHECK_IN: '/check-in',
    SYMPTOMS_SCREEN: '/symptoms-screen',
    COVID_POSITIVE: '/covid-positive',
    WFH_CONFIRM: '/wfh-conf',
    RESERVATION: '/reservation',
    ADMIN: '/admin',
    ROOT: '/'
}